import { Injectable } from "@angular/core";
import { PlatformService, PlatformResult, API_RESULT_STATUS } from './platform.service';
import { GeolocationPoint, DeviceInfos, DownloadUpdatesInfos, AppInfos, UploadLocalDatabaseInfos, UpdateInfos } from 'src/app/app.models';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import jsPDF from "jspdf";

export interface AndroidApi {
    getAppVersion(): string;

    takePhoto();
    onPhotoTaked(_result: PlatformResult);

    scanQRCode();
    onCodeScanned(_result: PlatformResult);

    scanDocument();
    onDocumentScanned(_result: PlatformResult);

    famocoScanLaser();
    onFamocoScanned(_result: PlatformResult);

    startListenLocation();
    stopListenLocation();
    onLocationChanged(_result: PlatformResult);
    
    getDeviceInfos();
    showNotification(id: string, message: string);
    printDocument(_filename: string, _html: string, openAfterPrint?: 0 | 1);

    downloadUpdatesApk(filename: string, downloadUrl: string, version: string);
    onUpdateAppStatus(status: any, progress?: number);

    uploadLocalDatabase(uploadUrl: string);
    onUploadLocalDatabaseStatus(status: any, progress?: number);

    connectHub(hubUrl: string);
    initApiEndpoint(endpoint: string);
    writeLogs(logs: string);

    scanBTDevices();
    onBTDevicesScanned(_result: PlatformResult);
    connectBTDevice(macAddress: string);
    disconnectBTDevice();
    printBTTicket(template: string, datas: string);

    newlandStartScan();
    onNewlandScanned(_result: PlatformResult);
}

@Injectable({
    providedIn: 'root'
})
export class PlatformAndroidService extends PlatformService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        //private _globalErrorHandler: GlobalErrorHandler,
    ) {
        super();
        this._initApiEndpoint();
        this._listenLocationChanged();
        this._listenKeyboardChanged();
        /*this._globalErrorHandler.traces$.subscribe(traces => {
            if (traces == null) { return; }
            const androidApi: AndroidApi = window['AndroidApi'];
            try {
                androidApi.writeLogs(JSON.stringify(traces));
            } catch(e) {}
        });*/
    }

    private _initApiEndpoint() {
        const androidApi: AndroidApi = window['AndroidApi'];
        androidApi.initApiEndpoint(JSON.stringify(this._apiService.coreEndPoints));
    }

    private _listenLocationChanged() {
        window['AndroidApi'].onLocationChanged = (_result: PlatformResult) => {
            if (_result.status == API_RESULT_STATUS.SUCCESS) {
                const location: GeolocationPoint = _result.datas;
                location.dateLocation = moment().format("YYYY-MM-DD HH:mm:ss");
                this.lastKnownLocation.next(_result.datas);
            }
        };
    }

    private _listenKeyboardChanged() {
        window['AndroidApi'].onKeyboardStateChanged = (_keyboardState: boolean) => {
            this.keyboardStatus.next(_keyboardState);
        };
    }

    get AppMode(): APP_MODE {
        const lsAppModeStr = localStorage.getItem(environment.LS_ABWORKFLOW_CORE_APP_MODE);
        let parsedAppMode = APP_MODE.ONLINE_MODE;
        if (!!lsAppModeStr && lsAppModeStr !== 'undefined' && lsAppModeStr !== 'null') { 
            parsedAppMode = parseInt(lsAppModeStr) == APP_MODE.OFFLINE_MODE ? APP_MODE.OFFLINE_MODE : APP_MODE.ONLINE_MODE;
        }
        return parsedAppMode;
    }
    
    get AppVersion(): AppInfos {
        const lsAppVersionStr = localStorage.getItem(environment.LS_ABWORKFLOW_APP_VERSION);
        let parsedAppVersion: AppInfos = { APP_VERSION_ID: '0.0.0', APP_VERSION_DISPLAY: '', APP_COMMIT_SHA: '', CODE_SOCIETE: '', NOM_SOCIETE: '' };
        if (!!lsAppVersionStr && lsAppVersionStr !== 'undefined' && lsAppVersionStr !== 'null') {
            try {
                parsedAppVersion = JSON.parse(lsAppVersionStr);
            } catch(e) {
            }
        }

        return parsedAppVersion;
    }

    getAppVersion(): Promise<AppInfos> {
        return new Promise(async (resolve, reject) => {
            const androidApi: AndroidApi = window['AndroidApi'];
            const deviceVersion = androidApi.getAppVersion();
            let appVersion = this.AppVersion;
            try {
                appVersion = await this._httpClient.get<AppInfos>(this._apiService.endPoints.GetAppVersion).toPromise();
            } catch(ex) {}
            resolve({ APP_VERSION_ID: deviceVersion, APP_COMMIT_SHA: appVersion.APP_COMMIT_SHA, APP_VERSION_DISPLAY: deviceVersion, CODE_SOCIETE: appVersion.CODE_SOCIETE, NOM_SOCIETE: appVersion.NOM_SOCIETE });
        })
    }

    deviceId(): string {
        return localStorage.getItem('ANDROID_ID');
    }

    showNotification(title: string, message: string, id?: string) {
        const androidApi: AndroidApi = window['AndroidApi'];
        androidApi.showNotification(title, message);
    }

    scanQRCode() {
        return new Promise<string>((resolve, reject) => {
            window['AndroidApi'].onCodeScanned = (_result: PlatformResult) => {
                delete window['AndroidApi'].onCodeScanned;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.scanQRCode()
        });
    }

    takePhoto() {
        return new Promise<string>((resolve, reject) => {
            window['AndroidApi'].onPhotoTaked = (_result: PlatformResult) => {
                delete window['AndroidApi'].onPhotoTaked;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.takePhoto()
        });
    }

    scanDocument() {
        return new Promise<string>((resolve, reject) => {
            window['AndroidApi'].onDocumentScanned = (_result: PlatformResult) => {
                delete window['AndroidApi'].onDocumentScanned;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.scanDocument()
        });
    }

    famocoScanLaser() {
        return new Promise<string>((resolve, reject) => {
            window['AndroidApi'].onFamocoScanned = (_result: PlatformResult) => {
                delete window['AndroidApi'].onFamocoScanned;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.famocoScanLaser()
        });
    }

    startListenLocation() {
        return new Promise<void>((resolve, reject) => {
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.startListenLocation();
            resolve();
        });
    }

    stopListenLocation() {
        const androidApi: AndroidApi = window['AndroidApi'];
        androidApi.stopListenLocation();
        this.lastKnownLocation.next(null);
    }

    getCurrentLocation() {
        return new Promise<GeolocationPoint>((resolve, reject) => {
            resolve(this.lastKnownLocation.value);
        });
    }

    getDeviceInfos() {
        return new Promise<DeviceInfos>((resolve, reject) => {
            window['AndroidApi'].onDeviceInfosFetched = (_result: PlatformResult) => {
                delete window['AndroidApi'].onDeviceInfosFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.getDeviceInfos();
        });
    }

    printDocument(_filename: string, _html: string, openAfterPrint: boolean) {
        /*const androidApi: AndroidApi = window['AndroidApi'];
        setTimeout(() => androidApi.printDocument(_html), 500);*/

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = _html;
        // height:842px;
        tempDiv.style.cssText = `background: #FFF;
                                    position: absolute;
                                    left: 0;
                                    right: 0;
                                    top: 0;
                                    bottom: 0px;
                                    width:595px;
                                    height: auto;
                                    padding: 20px;
                                    color: #000;
                                    overflow: hidden;`;
        document.body.appendChild(tempDiv); // requis pour que jsPDF puisse le rendre
        setTimeout(() => {
            const doc = new jsPDF("p", "pt", "a4");
            doc.html(tempDiv, {
                callback: (doc) => {
                    const blob = doc.output('blob');
                    this.blobToBase64(blob, (base64data) => {
                        const androidApi: AndroidApi = window['AndroidApi'];
                        androidApi.printDocument(_filename, base64data, openAfterPrint ? 1 : 0);
                    });
                    document.body.removeChild(tempDiv);
                },
                x: 0,
                y: 0
            });
        }, 0);
    }

    blobToBase64(blob, callback) {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = (reader.result as string).split(',')[1]; // enlever le préfixe data:...
            callback(base64data);
        };
        reader.readAsDataURL(blob);
    }

    downloadUpdates(downloadInfos: DownloadUpdatesInfos): Promise<void> {
        return new Promise((resolve, reject) => {
            window['AndroidApi'].onUpdateAppStatus = (_result: PlatformResult) => {
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    this.updatesStatus.next({ status: _result.status });
                    delete window['AndroidApi'].onUpdateAppStatus;
                } else if (_result.status == API_RESULT_STATUS.PENDING) {
                    this.updatesStatus.next({ status: _result.status, progress: _result.datas });
                } else {
                    this.updatesStatus.next({ status: _result.status });
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.downloadUpdatesApk(downloadInfos.filename, downloadInfos.url, downloadInfos.version);
            resolve();
        });
    }

    uploadLocalDatabase(uploadLocalDatabaseInfos: UploadLocalDatabaseInfos): Promise<void> {
        return new Promise((resolve, reject) => {
            window['AndroidApi'].onUploadLocalDatabaseStatus = (_result: PlatformResult) => {
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    this.uploadLocalDatabaseStatus.next({ status: _result.status });
                    delete window['AndroidApi'].onUploadLocalDatabaseStatus;
                } else if (_result.status == API_RESULT_STATUS.PENDING) {
                    this.uploadLocalDatabaseStatus.next({ status: _result.status, progress: _result.datas });
                } else {
                    this.uploadLocalDatabaseStatus.next({ status: _result.status });
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.uploadLocalDatabase(uploadLocalDatabaseInfos.UPLOAD_URL);
            resolve();
        });
    }

    installLatestUpdate(updateInfos: UpdateInfos) {
        const downloadUpdatesInfos: DownloadUpdatesInfos = {
            filename: `Abworkflow-${updateInfos.RELEASE_VERSION_CODE}.apk`,
            description: updateInfos.RELEASE_NOTE,
            url: updateInfos.RELEASE_URL,
            version: updateInfos.RELEASE_VERSION_CODE
        }
        return this.downloadUpdates(downloadUpdatesInfos);
    }

    // #region BT Functions
    scanBTDevices(): void {
        const androidApi: AndroidApi = window['AndroidApi'];
        window['AndroidApi'].onBTDevicesScanned = (_result: PlatformResult) => {
            if (_result.status == API_RESULT_STATUS.SUCCESS) {
                this.bluetoothDevicesScanned.next(_result.datas);
            }
        };
        androidApi.scanBTDevices();
    }

    connectBTDevice(macAddress: string) {
        return new Promise<DeviceInfos>((resolve, reject) => {
            window['AndroidApi'].onBtnDeviceConnection = (_result: PlatformResult) => {
                delete window['AndroidApi'].onBtnDeviceConnection;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(!!_result.datas?.details ? _result.datas.details : "Une erreur est survenue lors de la connexion au périphérique");
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.connectBTDevice(macAddress);
        });
    }

    disconnectBTDevice() {
        const androidApi: AndroidApi = window['AndroidApi'];
        androidApi.disconnectBTDevice();
    }

    printBTTicket(template: string, datas: any) {
        return new Promise<DeviceInfos>((resolve, reject) => {
            window['AndroidApi'].onPrintBTTicket = (_result: PlatformResult) => {
                delete window['AndroidApi'].onPrintBTTicket;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.printBTTicket(JSON.stringify(template), JSON.stringify(datas));
        });
    }
    // #endregion

    newlandStartScan() {
        return new Promise<string>((resolve, reject) => {
            window['AndroidApi'].onNewlandScanned = (_result: PlatformResult) => {
                delete window['AndroidApi'].onNewlandScanned;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const androidApi: AndroidApi = window['AndroidApi'];
            androidApi.newlandStartScan()
        });
    }
}